import React from "react";
import {
  Select,
  Table,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { DownOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";

import VehicleStore from "../store/VehicleStore";

import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";

import DriverLoginReportStore from "../store/DriverLoginReportStore";
import TripLogReportStore from "../store/TripLogReportStore";
const { RangePicker } = DatePicker;

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
class TripLogReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleStore = new VehicleStore();
    this.tripLogReportStore = new TripLogReportStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedDrivers: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      filterby: "",
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,
      NotDriver: false,
      expandedRowKeys: [],
      loadedInvoiceData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      hasInvoice: false,
      filterValue: "",
      filterNotSelected: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_NO_OF_TRIPS_"),
          dataIndex: "totalTrips",
          key: "totalTrips",
          width: "15%",
        },

        {
          title: context.translate(
            "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"
          ),
          dataIndex: "odometer",
          key: "odometer",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_DISTANCE_FARE_"),
          dataIndex: "totalTripDistanceFare",
          key: "totalTripDistanceFare",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_WAITING_TIME_FARE_"),
          dataIndex: "totalTripWaitingTimeFare",
          key: "totalTripWaitingTimeFare",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_VAT_"),
          dataIndex: "totalTaxAmount",
          key: "totalTaxAmount",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_FARE_"),
          dataIndex: "totalFare",
          key: "totalFare",
          width: "15%",
        },
      ]),
    };
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
        },

        {
          // label: "PDF",
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            filterBy: this.state.filterby,
            driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,

            colList: result.toString(),
            language: null,
          };

          if (val.key == "excel") {
            this.tripLogReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.tripLogReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDrivers: [],
      selectAllDrivers: false,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.driverLoginStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedDrivers.length === 0) {
      this.setState({ NotDriver: true });
    } else {
      this.setState({ NotDriver: false });
    }
    if (this.state.filterValue.length === 0) {
      this.setState({ filterNotSelected: true });
    } else {
      this.setState({ filterNotSelected: false });
    }
    if (
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedDrivers.length > 0) ||
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedVehicles.length > 0)
    ) {
      this.setState({ Notcompany: false, Notasset: false, NotDriver: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.tripLogReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          filterBy: this.state.filterby,
          vehicleId: this.state.selectedVehicles,
          driverId: this.state.selectedDrivers,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  expandedRowRender = (id) => {
    const columns = [
      {
        title: this.context.translate("_BOOKING_COMPANY_"),
        dataIndex: "companyName",
        key: "companyName",
        width: "10%",
      },
      {
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: "10%",
      },
      {
        title: this.context.translate("_FLEET_VEHICLE_VEHICLELIST_DRIVER_"),
        dataIndex: "driverName",
        key: "driverName",
        width: "10%",
      },
      {
        title: this.context.translate("_ORDER_CHANNEL_"),
        dataIndex: "orderChannelId",
        key: "orderChannelId",
        width: "10%",
        render: (value, record) => {
          switch (parseInt(record.orderChannelId, 10)) {
            case 1:
              return "App";
            case 2:
              return "Local";
            case 3:
              return "Call Center";
            default:
              return "App";
          }
        },
      },
      {
        title: this.context.translate("_PAYMENT_TYPE_"),
        dataIndex: "paymentMethod",
        key: "paymentMethod",
        width: "10%",
        render: (value, record) => {
          switch (record.paymentMethod) {
            case 1:
              return "Cash";
            case 2:
              return "Card";
            case 3:
              return "QRIS";
            default:
              return "Cash";
          }
        },
      },
      {
        title: this.context.translate("_FARE_TYPE_"),
        dataIndex: "selectedFareType",
        key: "selectedFareType",
        width: "10%",
        render: (value, record) => {
          switch (record.selectedFareType) {
            case 1:
              return "Fixed";
            case 2:
              return "Estimated";
            default:
              return "Estimated";
          }
        },
      },
      {
        title: this.context.translate("_PICKUP_TIME_"),
        dataIndex: "tripStartTime",
        key: "tripStartTime",
        width: "10%",
      },
      {
        title: this.context.translate("_PICKUP_LOCATION_"),
        dataIndex: "pickupAddress",
        key: "pickupAddress",
        width: "10%",
      },

      {
        title: this.context.translate("_DROP_TIME_"),
        dataIndex: "tripEndTime",
        key: "tripEndTime",
        width: "10%",
      },
      {
        title: this.context.translate("_DROP_LOCATION_"),
        dataIndex: "dropAddress",
        key: "dropAddress",
        width: "10%",
      },
      {
        title: this.context.translate(
          "_FLEET_RULEDETAIL_SELECTPARAMETER_DISTANCE_"
        ),
        dataIndex: "tripdistance",
        key: "tripdistance",
        width: "10%",
      },
      {
        title: this.context.translate("_WAITING_TIME_"),
        dataIndex: "waitingTime",
        key: "waitingTime",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: this.context.translate("_VAT_"),
        dataIndex: "taxAmount",
        key: "taxAmount",
        width: "12%",
      },
      {
        title: this.context.translate("_TRIP_DURATION_"),
        dataIndex: "duration",
        key: "duration",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: this.context.translate("_BASIC_FARE_"),
        dataIndex: "basicFare",
        key: "basicFare",
        width: "12%",
      },
      {
        title: this.context.translate("_DISTANCE_FARE_"),
        dataIndex: "tripDistanceFare",
        key: "tripDistanceFare",
        width: "12%",
      },
      {
        title: this.context.translate("_WAITING_FARE_"),
        dataIndex: "tripWaitingTimeFare",
        key: "tripWaitingTimeFare",
        width: "12%",
      },
      {
        title: this.context.translate("_TOLL_"),
        dataIndex: "toll",
        key: "toll",
        width: "12%",
      },
      {
        title: this.context.translate(
          "_FLEET_DASHBORD_NEWPOI_TYPEDDL_AIRPORT_"
        ),
        dataIndex: "airport",
        key: "airport",
        width: "12%",
      },
      {
        title: this.context.translate("_PARKING_"),
        dataIndex: "parking",
        key: "parking",
        width: "12%",
      },
      {
        title: this.context.translate("_TOTAL_FARE_"),
        dataIndex: "totalFare",
        key: "totalFare",
        width: "12%",
      },
    ];

    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          // scroll={{ x: 50 }}
          dataSource={this.tripLogReportStore.tripData}
          pagination={false}
        />
      </div>
    );
  };

  onExpand = async (expanded, record) => {
    const expandedRowKeys = expanded ? [record.driverId] : [];
    this.setState({ expandedRowKeys });

    if (expanded) {
      await this.handleExpandRow(record);
    }
  };

  handleExpandRow = async (record) => {
    this.setState({ innerGridData: record });
    if (!this.state.loadedInvoiceData[record.driverId]) {
      await this.tripLogReportStore.loadTripLogData({
        vehicleId: record.vehicleId,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        companyId: this.state.companyId,
      });
      this.setState((prevState) => ({
        loadedInvoiceData: {
          ...prevState.loadedInvoiceData,
          [record.startTime]: true,
        },
      }));
    }
  };

  formatDuration = (value) => {
    const d = Number(value);

    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor(d % 60);

    const hDisplay = h > 0 ? String(h).padStart(2, "0") + ":" : "00:";
    const mDisplay = m > 0 ? String(m).padStart(2, "0") + ":" : "00:";
    const sDisplay = s > 0 ? String(s).padStart(2, "0") : "00";

    return hDisplay + mDisplay + sDisplay;
  };

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed">
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_TRIP_LOG_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.tripLogReportStore?.tripLogReportData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                <Select
                  style={{ width: 130 }}
                  // placeholder='Filter by'
                  status={this.state.filterNotSelected ? "error" : false}
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    this.setState({ filterValue: val });

                    this.setState({
                      filterby: val,
                      selectedDrivers: [],
                      selectedVehicles: [],
                      selectAllDrivers: false,
                      selectAllVehicles: false,
                    });
                  }}
                >
                  <Select.Option value="Driver">
                    {this.context.translate(
                      "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                    )}
                  </Select.Option>

                  <Select.Option value="Vehicle">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option>
                </Select>
                {this.state.filterby == "Vehicle" && (
                  <>
                    <Select
                      maxTagCount="responsive"
                      value={this.state.selectedVehicles}
                      onChange={(val) => {
                        this.setState({ selectedVehicles: val });
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.Notasset ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_VEHICLE_NO_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option key={val.vehicleId} value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </>
                )}
                {this.state.filterby == "Driver" && (
                  <>
                    <Select
                      maxTagCount="responsive"
                      value={
                        this.state.selectedDrivers
                        // ? this.state.selectedDrivers
                        // : null
                      }
                      onChange={(val) => {
                        this.setState({ selectedDrivers: val });
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.NotDriver ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.driverLoginStore?.getDrivers?.map((val) => {
                        return (
                          <Option key={val.driverId} value={val.driverId}>
                            {val.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </>
                )}

                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 380 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
          </Row>

          <ListTable
            rowKey="driverId"
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.tripLogReportStore?.total}
            columns={this.state.column}
            dataSource={this.tripLogReportStore?.tripLogReportData}
            loading={this.tripLogReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
TripLogReport.contextType = StoreContext;
export default observer(withRouter(TripLogReport));
